import React, { memo } from 'react';
import { Wrapper } from '../../ModulePage';
export var Account = memo(function () { return (React.createElement(React.Fragment, null,
    React.createElement(Wrapper, { id: "Container", style: { paddingTop: '200px' } },
        React.createElement("h1", null, "M\u016Fj \u00FA\u010Det")))); });
